import { AxiosInstance } from 'axios';
import { SystemTroubleContactSettingRepository } from '@/model/repository/manager/communications/SystemTroubleContactSettingRepository';
import axios from 'axios';

export default (Repository: AxiosInstance | null) =>
  (resource: string): SystemTroubleContactSettingRepository => ({
    put(payload) {
      const axiosInstance = Repository ?? axios.create({ withCredentials: true });
      return axiosInstance.put(`${resource}`, payload);
    },

    get() {
      const axiosInstance = Repository ?? axios.create({ withCredentials: true });
      return axiosInstance.get(`${resource}`);
    },

    delete() {
      const axiosInstance = Repository ?? axios.create({ withCredentials: true });
      return axiosInstance.delete(`${resource}`);
    },
  });
